import { gql } from '@apollo/client';

export const GET_CASE_MANAGEMENT = gql`
  query GetCaseManagement($id: ID) {
    caseManagement: getCaseManagement(id: $id) {
      id
      documentTypes {
        id
        name
        description
        startDate
        endDate
        status
        required
        expiryDateRequired
        type
      }
      monitoringGroups {
        id
        group {
          id
          name
          groupDescription
          numberOfOptions
        }
        startDate
        endDate
        status
      }
    }
  }
`;
